module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo05.fb776d09.jpg";